window.activeWaveSurfer = null;
window.waveSurferRegistry = {};

window.registerWaveSurfer = (id, instance) => {
    window.waveSurferRegistry[id] = instance;
};

window.playWaveSurfer = (id) => {
    const ws = window.waveSurferRegistry[id];
    if (!ws) return;
    
    if (window.activeWaveSurfer && window.activeWaveSurfer !== ws) {
        window.activeWaveSurfer.pause();
        window.activeWaveSurfer.setTime(0);
    }

    if (ws.isPlaying()) {
        ws.pause();
    } else {
        if (ws.getCurrentTime() >= ws.getDuration()) {
            ws.setTime(0);
        }
        ws.play();
    }
    window.activeWaveSurfer = ws;
};

window.initWaveSurfer = (containerId, audioUrl, playBtnId, timeId) => {
    const container = document.getElementById(containerId);
    if (!container) {
        console.warn("Waveform container not found:", containerId);
        return;
    }

    const id = containerId.replace('waveform-', '');
    if (window.waveSurferRegistry[id]) {
        window.destroyWaveSurfer(id);
    }

    const wavesurfer = WaveSurfer.create({
        container: `#${containerId}`,
        waveColor: '#8D93A7',
        progressColor: '#5546C0',
        cursorWidth: 0,
        height: 40,
        barWidth: 2,
        barGap: 2,
        barRadius: 2,
        responsive: true,
        normalize: true,
        fillParent: true,
    });

    wavesurfer.load(audioUrl);

    wavesurfer.on('ready', () => {
        wavesurfer.setTime(0);
        if (time) time.textContent = "00:00";
    });

    const playBtn = document.getElementById(playBtnId);
    const time = document.getElementById(timeId);

    const playIcon = playBtn.querySelector('.play-icon');
    const pauseIcon = playBtn.querySelector('.pause-icon');

    window.registerWaveSurfer(containerId.replace('waveform-', ''), wavesurfer);

    function setPlayingUI(isPlaying) {
        playIcon.classList.toggle('hidden', isPlaying);
        pauseIcon.classList.toggle('hidden', !isPlaying);
    }

    playBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const id = containerId.replace('waveform-', '');
        window.playWaveSurfer(id);
    });

    wavesurfer.on('play', () => {
        if (window.activeWaveSurfer && window.activeWaveSurfer !== wavesurfer) {
            window.activeWaveSurfer.pause();
        }
        window.activeWaveSurfer = wavesurfer;
        setPlayingUI(true);
    });

    wavesurfer.on('pause', () => {
        setPlayingUI(false);
    });

    wavesurfer.on('finish', () => {
        setPlayingUI(false);
    });

    wavesurfer.on('audioprocess', () => {
        time.textContent = formatTime(wavesurfer.getCurrentTime());
    });

    function formatTime(sec) {
        const m = Math.floor(sec / 60);
        const s = Math.floor(sec % 60);
        return `${m}:${s.toString().padStart(2, '0')}`;
    }
};

window.destroyWaveSurfer = (id) => {
    const ws = window.waveSurferRegistry[id];
    if (ws) {
        ws.destroy();
        delete window.waveSurferRegistry[id];
        if (window.activeWaveSurfer === ws) {
            window.activeWaveSurfer = null;
        }
    }
};